<template>
  <v-app id="addeign">
    <v-main>
      <v-container fluid>
        <v-form ref="addEign" v-model="addEignValid"> 
          <v-row>
            <v-col cols="2">
             <v-select v-model="bedrCodeSelected" :items="bedrCodes" item-value="bedr_code" item-text="bedr_code" label="Company"></v-select>
            </v-col>
            <v-col cols="4">
             <v-text-field v-model="eign_naam" :rules="eign_naamRules" label="Last name"></v-text-field>
            </v-col>
          </v-row>
           <v-row>
            <v-col cols="2">
             <v-select v-model="landCodeSelected" :items="landCodes" item-value="land_code" item-text="land_code" label="Country"></v-select>
            </v-col>
            <v-col cols="2">
             <v-select v-model="taalCodeSelected" :items="taalCodes" item-value="taal_code" item-text="taal_code" label="Language"></v-select>
            </v-col>
          </v-row>

           <v-row>
            <v-col cols="2">
             <v-select v-model="gebrCodeSelected" :items="gebrCodes" item-value="gebr_code" item-text="gebr_naam" label="Agent"></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="1">
            <v-btn class="primary ma-0" small :disabled="!addEignValid" @click="addEign">Add</v-btn>
            </v-col> 
          </v-row>
        </v-form>
      </v-container>
    </v-main>
    <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main"/>
  </v-app>
</template>

<script>
 import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      addEignValid: false,
      eign_naam: '',
      bedrCodeSelected: '',
      bedrCodes: [],
      landCodeSelected: '',
      landCodes: [],
      taalCodeSelected: '',
      taalCodes: [],
      gebrCodeSelected: '',
      gebrCodes: [],
      eign_naamRules: [
          v => (v && v.length >= 3) || "A Lastname is requird"
      ]
    }    
  },
  created() {
    var deze = this;
    this.$axios
      .post("ares/json/ares/eign/getToAddEign.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getToAddEign"
        },
        getToAddEign: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           res.data.getToAddEign.forEach(function(eignBedr) {
            deze.bedrCodes.push(eignBedr.bedr_code);
            if(eignBedr.selected === true) {
               deze.bedrCodeSelected = eignBedr.bedr_code;
            }   
          });
          res.data.landKeuzes.forEach(function(land) {
            deze.landCodes.push(land.land_code);
            if(land.selected === true) {
               deze.landCodeSelected = land.land_code;
            }   
          });
           res.data.gebrKeuzes.forEach(function(gebr) {
            deze.gebrCodes.push(gebr);
            if(gebr.selected === true) {
               deze.gebrCodeSelected = gebr.gebr_code;
            }   
          });
          res.data.taalKeuzes.forEach(function(taal) {
            deze.taalCodes.push(taal.taal_code);
            if(taal.selected === true) {
               deze.taalCodeSelected = taal.taal_code;
            }   
          });
        }
      });

  },
  methods: {
     addEign() {
      this.$axios
        .post("ares/json/ares/eign/addEign.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addEign"
          },
          addEign: {
            bedr_code: this.bedrCodeSelected,
            eign_naam: this.eign_naam,
            land_code: this.landCodeSelected,
            gebr_code: this.gebrCodeSelected,
            taal_code: this.taalCodeSelected
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
             this.$router.reload('/eign/onEign/' + res.data.addEign.eign_encrid);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};

</script> 
